import { useEffect, useState } from 'react';
import { Platform, Dimensions } from 'react-native';
import Orientation from 'react-native-orientation-locker';
function calcIsCompact() {
    const { height, width } = Dimensions.get('window');
    const shortSide = Math.min(height, width);
    return shortSide < 600;
}
const isAndroid = Platform.OS === 'android';
const isIPhone = Platform.OS === 'ios' && !Platform.isPad;
const isCompact = calcIsCompact();
export const useOrientationLocker = () => {
    const [isAppLocked, setIsAppLocked] = useState((isAndroid && isCompact) || isIPhone);
    useEffect(() => {
        let isAppLockedInternal = (isAndroid && isCompact) || isIPhone;
        Orientation.getAutoRotateState((isAutoRotateEnabled) => {
            isAppLockedInternal = isAppLockedInternal || (isAndroid && !isAutoRotateEnabled);
            if (isAppLockedInternal) {
                Orientation.lockToPortrait();
            }
            else {
                Orientation.unlockAllOrientations();
            }
            setIsAppLocked(isAppLockedInternal);
        });
    }, []);
    return isAppLocked;
};
//# sourceMappingURL=useOrientationLocker.js.map